module.exports = __webpack_public_path__ + "media/login.5b2dba54.jpg";